import styled from 'styled-components';

import { Button } from '@xingternal/button';
import { IllustrationSpotConfetti } from '@xingternal/illustrations';
import { mediaConfined } from '@xingternal/layout-tokens';
import { space5XL, spaceL, spaceS, spaceXL, spaceXXL } from '@xingternal/tokens';
import { BodyCopy, Headline, Hero } from '@xingternal/typography';

export const ContentWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: ${space5XL} 0;
`;

export const CheckImg = styled(IllustrationSpotConfetti)`
  margin-bottom: ${spaceL};

  @media ${mediaConfined} {
    margin-bottom: ${spaceXL};
  }
`;

export const MobileTitle = styled(Headline)`
  margin-bottom: ${spaceS};
`;

export const Title = styled(Hero)`
  margin-bottom: ${spaceS};
`;

export const Body = styled(BodyCopy)`
  margin-bottom: ${spaceXL};
  text-align: center;

  @media ${mediaConfined} {
    margin-bottom: ${spaceXXL};
  }
`;

export const CtaButton = styled(Button)`
  margin-bottom: ${spaceL};
`;
